import React from "react";
import {
  Image,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import fontBold from "../pdf/fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "../pdf/fonts/NotoSansTamil-Regular.ttf";

Font.register({
  family: "NotoSansTamil",
  fonts: [
    { src: fontRegular, fontWeight: "normal" },
    { src: fontBold, fontWeight: "bold" },
  ],
});
// Create styles for exact alignment and layout
const styles = StyleSheet.create({
  print: {
    fontWeight: "bold",
    fontSize: 16,
    textAlign: "right",
  },
  page: {
    padding: 10,
    fontSize: 10,
    fontFamily: "Helvetica",
    border: "2 solid black",
  },
  container: {
    padding: 10,
    marginTop: 10,
  },
  headerContainer: {
    borderBottom: "1 solid black",
    border: "1 solid black", // Border around the header
    padding: 0,
    marginBottom: 5,
  },

  headerTop: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerLeft: {
    width: "30%",
    paddingRight: 0,
    textAlign: "left",
    paddingLeft: 3,
  },
  headerRight: {
    width: "40%",
    padding: 0,
    textAlign: "right",
    paddingRight: 3,
  },
  headerTopCenter: {
    width: "50%",
    paddingLeft: 45,
  },
  headerImgLeft: {
    width: "10%",
    paddingRight: 0,
    marginBottom: 10,
  },
  headerImgRight: {
    width: "10%",
    padding: 0,
    marginRight: 8,
    marginBottom: 10,
  },
  headerCenter: {
    width: "80%", // Center portion for the title
    textAlign: "center",
    paddingBottom: 10,
  },
  centerContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",

    paddingBottom: 0,
    borderBottom: "1 solid black",
  },
  paddingBottom: {
    paddingBottom: 10,
    marginLeft: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },
  paddingBottomName: {
    paddingBottom: 10,
    marginLeft: 2,
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "left",
  },
  partyName: {
    fontSize: 17,
    fontWeight: "bold",
  },
  partyadd: {
    fontSize: 14,
  },
  invoice: {
    paddingTop: 10,
    paddingBottom: 8,
    paddingLeft: 2,
    alignItems: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  date: {
    paddingTop: 22,
      paddingLeft: 3,
    borderTop: "1 solid black",
    alignItems: "center",    
    fontSize: 13,
    fontWeight: "bold",
  },
  marginLeft: {
    marginLeft: 2,
    marginBottom: 2,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },

  image: {
    width: "60px",
    height: "70px",
  },
  invoiceSpace: {
    paddingLeft: 2,
    marginTop: 0,
    marginBottom: 0,
  },
  dateSpace: {
    paddingLeft: 2,
    marginTop: 8,
  },
  companyTitle: {
    fontSize: 18, // Increased font size for emphasis
    fontWeight: "bold", // Ensures the text is thick
    textAlign: "center",
    letterSpacing: 0, // Spreads out the letters for visual impact
    textTransform: "uppercase", // Converts text to uppercase
    transform: [{ rotate: "180deg" }],
    color: "black", // Replace with the dark shade from the image
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)", // Mimics the shadow effect
  },

  taxWrapper: {
    backgroundColor: "black",
    alignSelf: "flex-start",
    paddingHorizontal: 5,
    borderRadius: 5,
    marginLeft: 160,
  },
  companyTaxTitle: {
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "center",
    color: "white", // Text color remains white
  },
  companyMargin: {
    textAlign: "center",
    paddingTop: 5,
  },
  companyHeadMargin: {
    textAlign: "center",

    marginBottom: 0,
    paddingRight: 30,
  },

  contactInfo: {
    fontSize: 10,
  },
  gstNumber: {
    fontSize: 10,
    marginTop: 2,
  },
  invoiceDetailsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sectionLeft: {
    width: "75%",
  },
  marginBottom: {
    marginBottom: 5,
    marginLeft: 3,
  },
  sectionRight: {
    width: "25%",

    textAlign: "left",
    borderLeft: "1 solid black",
  },
  bold: {
    fontSize: 13,
    fontWeight: "bold",
  },
  tableHeader: {
    flexDirection: "row",
    borderTop: "1 solid black",
    borderBottom: "1 solid black",
    backgroundColor: "#f0f0f0",
    paddingVertical: 0,
    width: "100%",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1 solid black",
    // Height: 20, <--- REMOVED TO DECREASE HEIGHT
  },
  tableCol: {
    display: "flex",
    width: "15%",
    borderRight: "1 solid black",
    textAlign: "center",
    alignItems: "center",
    // Original: paddingVertical: 9,
    paddingVertical: 4, // <--- DECREASED
  },
  tableColl: {
    width: "15%",
    borderRight: "1 solid black",
    textAlign: "center",
    // Original: paddingVertical: 8,
    paddingVertical: 4, // <--- DECREASED
    fontSize: 10,
    fontWeight: "bold",
  },
  valueTableCol: {
    width: "18%",
    borderRight: "1 solid black",
    textAlign: "center",
  },
  tablePrice: {
    display: "flex",
    flexDirection: "column",
    width: "18%",
    borderRight: "1 solid black",
    textAlign: "center",
    paddingVertical: 3,
  },
  tableeRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",

    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableeAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",

    textAlign: "center",
    fontSize: 13,
    fontWeight: "bold",
  },
  tableRate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    textAlign: "center",
   
  },
  tableAmount: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
   

    textAlign: "center",
  },
  tableRsValue: {
    width: "70%",
    borderRight: "1 solid black",
    textAlign: "center",
    // Original: paddingVertical: 12,
    paddingVertical: 4, // <--- DECREASED
  },
  tablePsValue: {
    width: "30%",
    // Original: paddingVertical: 12,
    paddingVertical: 4, // <--- DECREASED
    textAlign: "center",
   
  },
  tableRs: {
    width: "70%",

    textAlign: "center",
  },
  tablePs: {
    width: "30%",

    textAlign: "center",
  },

  tableColFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    display: "flex",
    // Original: paddingTop: 9,
    paddingVertical: 4, // <--- DECREASED & CHANGED TO paddingVertical
    alignItems: "center",
  },
  tableCollFirst: {
    width: "20%",
    borderLeft: "1 solid black",
    borderRight: "1 solid black",
    textAlign: "center",
    // Original: paddingVertical: 8,
    paddingVertical: 4, // <--- DECREASED
    fontSize: 13,
    fontWeight: "bold",
  },
  tableColLarge: {
    width: "25%",
    borderRight: "1 solid black",
    textAlign: "center",
   

    // Original: paddingTop: 9,
    paddingVertical: 4, // <--- DECREASED & CHANGED TO paddingVertical
  },
  tableCollLarge: {
    width: "25%",
    borderRight: "1 solid black",
    textAlign: "center",
       

    // Original: paddingVertical: 8,
    paddingVertical: 4, // <--- DECREASED
    fontSize: 13,
    fontWeight: "bold",
  },
  footerContainer: {
    marginTop: 5,
    paddingTop: 0,
    borderTop: "1 solid black",
    border: "1 solid black", // Border around the footer section
  },
  borderTop: {
    borderTop: "1 solid black",
    paddingVertical: 7, // Kept at 7 for consistency
    
  },
  footerLeft: {
    width: "70%",
    borderRight: "1 solid black",
    padding: 0,
  },
  footerRight: {
    width: "30%",
    padding: 0,
    display: "flex",
    flexDirection: "row",
  },
  firstFooterOne: {
    borderRight: "1 solid black",
    width: "50%",
    textAlign: "right",
  },
  firstFooterTwo: {
    paddingVertical: 7, // Adjusted padding
    fontSize: 10, // Added font size
  },

  secondFooterOne: {
    borderRight: "1 solid black",
    width: "30%",
    textAlign: "center", // FIX: Changed from 'center' for proper numeric alignment
  },
  secondFooterTwo: {
    paddingVertical: 7,
    fontSize: 10, // Added font size
  },
  thirdFooterOne: {
    width: "20%",
    textAlign: "center", // FIX: Changed from 'center' for proper numeric alignment
  },
  thirdFooterTwo: {
    paddingVertical: 7,
    fontSize: 10, // Added font size
    textAlign:"center",
  },
  footerSign: {
    marginBottom: 20,
    fontFamily: "Helvetica",
  },
  footerBottom: {
    flexDirection: "column",
    borderTop: "1 solid black",
    marginTop: 5,
    marginBottom: 0,

    justifyContent: "space-between",

    border: "1 solid black", // Border around the footer bottom section
  },
  footerleft: {
    marginRight: 100,
  },
  footerNote: {
    fontSize: 8,
    textAlign: "center",
    marginTop: 10,
    marginBottom: 0,
  },
  topHead: {
   
    fontFamily: "NotoSansTamil",
    paddingRight: 10,
    marginTop: -10,
    marginBottom: 5,
  },
});

// Helper function to split values into Rs and Ps
const splitIntoRsPs = (value) => {
  if (!value || isNaN(value)) return { rs: "", ps: "" };
  // Use Math.round to ensure proper rounding before splitting
  const [rs, ps] = (Math.round(value * 100) / 100).toFixed(2).split("."); 
  return { rs, ps };
};
function convertRupeesToWordsWithBreaks(amount) {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function convertGroup(number, thousandIndex) {
    if (number === 0) return "";

    let str = "000" + number;
    str = str.slice(-3);

    const hundred = parseInt(str[0], 10);
    const ten = parseInt(str[1], 10);
    const one = parseInt(str[2], 10);

    let words = [];

    if (hundred > 0) {
      words.push(ones[hundred] + " Hundred");
    }

    if (ten === 1) {
      words.push(teens[one]);
    } else {
      if (ten > 0) {
        words.push(tens[ten]);
      }
      if (one > 0) {
        words.push(ones[one]);
      }
    }

    if (thousandIndex > 0 && words.length > 0) {
      words.push(thousands[thousandIndex]);
    }

    return words.join(" ");
  }

  function convertIntegerPart(integerPart) {
    const groups = [];
    let thousandIndex = 0;

    while (integerPart > 0) {
      const divisor = thousandIndex === 1 ? 100 : 1000; // 100 for thousands, 1000 for lakhs onwards
      groups.push(convertGroup(integerPart % divisor, thousandIndex));
      integerPart = Math.floor(integerPart / divisor);
      thousandIndex++;
    }

    const resultGroups = groups.reverse().filter((group) => group !== "");
    const lastGroupIndex = resultGroups.length - 1;
    const formattedGroups = resultGroups.map((group, index) =>
      index === lastGroupIndex ? `${group}` : group
    );

    return formattedGroups.join(" ");
  }

  function convertDecimalPart(decimalPart) {
    if (decimalPart === 0) {
      return "";
    }

    let paise = Math.round(decimalPart * 100);
    return `${convertGroup(paise, 0)} Paise`;
  }

  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;

  const integerWords = convertIntegerPart(integerPart);
  const decimalWords = convertDecimalPart(decimalPart);

  const result =
    integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
  return result.trim();
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const currentYear = date.getFullYear().toString();
  const nextYear = (date.getFullYear() + 1).toString().slice(-2);
  return `${day}/${month}/${currentYear}`;
};

// Create Document Component
const InvoicePDF = ({ data, type }) => {
  console.log("data", data);
  const words = convertRupeesToWordsWithBreaks(data.total);

  let totalCGST = 0;
  let totalSGST = 0;
  let totalIGST = 0;

  data.products.forEach((product) => {
    if (product.tax_type === "GST") {
      const halfTax = product.tax_amt / 2;
      totalCGST += halfTax;
      totalSGST += halfTax;
    } else {
      totalIGST += product.tax_amt;
    }
  });
  const IGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt),
    0
  );
  const SGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt / 2),
    0
  );
  const CGST = data.products.reduce(
    (acc, product) => acc + parseFloat(product.tax_amt / 2),
    0
  );

  // Set rowsPerPage to a safe value (13) to ensure all content fits on one page.
  const rowsPerPage = 13; 
  const productChunks = [];

  for (let i = 0; i < data.products.length; i += rowsPerPage) {
    productChunks.push(data.products.slice(i, i + rowsPerPage));
  }

  return (
    <Document>
      {productChunks.map((productChunk, pageIndex) => {
        const isLastPage = pageIndex === productChunks.length - 1;
        const totalRowsOnPage = productChunk.length;
        // Determine the number of empty filler rows needed on this page
        const fillerRowsCount = rowsPerPage - totalRowsOnPage;

        return (
          <Page size="A4" style={styles.page} key={pageIndex}>
            <View style={styles.container}>
              {/* Header - Remains the same on all pages */}
              <Text style={[styles.print]}>[{type}] </Text>
              <View style={styles.headerContainer}>
                <View style={styles.headerTop}>
                  <View style={styles.headerLeft}>
                    <Text>GSTIN: 33KYXPK6790J1ZA</Text>
                  </View>

                  <View style={styles.headerRight}>
                    <Text style={styles.invoiceSpace}>HSN Code:3604</Text>
                  </View>
                </View>
                <View style={styles.centerContainer}>
                  <View style={styles.headerImgLeft}>
                    <Image
                      src="https://t4.ftcdn.net/jpg/01/25/63/07/360_F_125630792_Y7FBQO4f779brbK3kw87iIihK7GE0aAO.jpg" // Image URL
                      style={styles.image}
                    />
                  </View>
                  <View style={styles.headerCenter}>
                    <Text style={styles.topHead}>
                      ஸ்ரீ ஆத்தடி முத்து கருப்பசாமி துணை
                    </Text>

                    <View style={styles.taxWrapper}>
                      <Text style={styles.companyTaxTitle}>TAX INVOICE</Text>
                    </View>
                    <Text style={styles.companyTitle}>SUN WORD TRADERS</Text>
                    <Text style={styles.companyMargin}>
                      5/23-1, North Street,Akkaraipatti, Vembakottai.
                    </Text>
                    <Text style={styles.companyMargin}>
                      Sivakasi, Virudhunagar (Dist) Tamil Nadu - 626 131
                    </Text>
                  </View>
                  <View style={styles.headerImgRight}>
                    <Image
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHSN-BemaprtWLPemWtPu1eaqXRnIjBlhsxWbbTNFjc6TEQTOCZAnVoKaVpNwImW3qWsc&usqp=CAU" // Image URL
                      style={styles.image}
                    />
                  </View>
                </View>
                <View style={styles.invoiceDetailsContainer}>
                  <View style={styles.sectionLeft}>
                    <Text style={styles.paddingBottomName}>
                      M/s. {data.partyname}
                    </Text>
                    <Text style={styles.paddingBottom}>
                      Address: {data.partyaddress}
                    </Text>

                    <Text style={styles.paddingBottom}>
                      Party's GST IN:{data.purchase_gst}
                    </Text>
                    <Text style={styles.marginLeft}>HSN Code:</Text>
                  </View>
                  <View style={styles.sectionRight}>
                    <Text style={styles.invoice}>Invoice No: {data.bill_no}</Text>
                    <Text style={styles.date}>
                      Date: {formatDate(data.bill_date)}
                    </Text>
                  </View>
                </View>
              </View>

              {/* Table Header - Remains the same on all pages */}
              <View style={styles.tableHeader}>
                <Text style={styles.tableCollFirst}>Marks & No.</Text>
                <Text style={styles.tableCollLarge}>Particulars</Text>

                <Text style={styles.tableColl}>Quantity</Text>
                <View style={styles.tablePrice}>
                  <Text style={styles.bold}>Rate</Text>
                  <View style={styles.tableeRate}>
                    <Text style={styles.tableRs}>Rs.</Text>
                    <Text style={styles.tablePs}>Ps.</Text>
                  </View>
                </View>
                <Text style={styles.tableColl}>Per</Text>
                <View style={styles.tablePrice}>
                  <Text style={styles.bold}>Amount</Text>
                  <View style={styles.tableeAmount}>
                    <Text style={styles.tableRs}>Rs.</Text>
                    <Text style={styles.tablePs}>Ps.</Text>
                  </View>
                </View>
              </View>
              {/* Table Rows (Product + Filler + Total Cases) */}
              {productChunk.map((product, index) => {
                const qty = product.qty || "";
                const priceUnit = product.price_unit || "";
                const amount = qty && priceUnit ? qty * priceUnit : "";

                const perRateSplit = splitIntoRsPs(priceUnit || 0);
                const amountSplit = splitIntoRsPs(amount || 0);

                return (
                  <View style={styles.tableRow} key={index}>
                    <Text style={styles.tableColFirst}>
                      {product.MarksNo || ""}
                    </Text>
                    <Text style={styles.tableColLarge}>
                      {product.product_name || ""}
                    </Text>
                    <Text style={styles.tableCol}>{qty}</Text>
                    <View style={styles.valueTableCol}>
                      <View style={styles.tableRate}>
                        <Text style={styles.tableRsValue}>{perRateSplit.rs}</Text>
                        <Text style={styles.tablePsValue}>{perRateSplit.ps}</Text>
                      </View>
                    </View>
                    <Text style={styles.tableCol}>{product.unit_name || ""}</Text>
                    <View style={styles.valueTableCol}>
                      <View style={styles.tableAmount}>
                        <Text style={styles.tableRsValue}>{amountSplit.rs}</Text>
                        <Text style={styles.tablePsValue}>{amountSplit.ps}</Text>
                      </View>
                    </View>
                  </View>
                );
              })}

              {/* Filler Rows & Total Cases Row */}
              {Array.from({ length: fillerRowsCount }).map((_, index) => {
                // Determine if this is the last available slot on the last page chunk
                const isTotalCasesSlot = isLastPage && index === fillerRowsCount - 1 && data.total_cases && parseFloat(data.total_cases) > 0;

                if (isTotalCasesSlot) {
                  return (
                    <View style={styles.tableRow} key={`total-cases-${index}`}>
                      <Text style={styles.tableColFirst}></Text>
                      <Text style={[styles.tableColLarge, { fontWeight: "bold", paddingVertical: 4 }]}>
                        Total
                      </Text>
                      <Text style={[styles.tableCol, { fontWeight: "bold", textAlign: "center" }]}>
                        {data.total_cases}
                      </Text>
                      <View style={styles.valueTableCol}>
                        <View style={styles.tableRate}>
                          <Text style={styles.tableRsValue}> </Text>
                          <Text style={styles.tablePsValue}> </Text>
                        </View>
                      </View>
                      <Text style={styles.tableCol}></Text>
                      <View style={styles.valueTableCol}>
                        <View style={styles.tableAmount}>
                          <Text style={styles.tableRsValue}> </Text>
                          <Text style={styles.tablePsValue}> </Text>
                        </View>
                      </View>
                    </View>
                  );
                }

                // Normal filler row
                return (
                  <View style={styles.tableRow} key={`filler-${index}`}>
                    <Text style={styles.tableColFirst}></Text>
                    <Text style={styles.tableColLarge}></Text>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.valueTableCol}>
                      <View style={styles.tableRate}>
                        <Text style={styles.tableRsValue}> </Text>
                        <Text style={styles.tablePsValue}> </Text>
                      </View>
                    </View>
                    <Text style={styles.tableCol}></Text>
                    <View style={styles.valueTableCol}>
                      <View style={styles.tableAmount}>
                        <Text style={styles.tableRsValue}> </Text>
                        <Text style={styles.tablePsValue}> </Text>
                      </View>
                    </View>
                  </View>
                );
              })}


              {/* FIX 2: Ensure footer only renders on the last page chunk */}
             
                <>
                  <View style={styles.footerContainer}>
                    <View style={{ flexDirection: "row" }}>
                      <View style={styles.footerLeft}>
                        <Text style={styles.marginBottom}>
                          Despatched by: {data.despatched_by}
                        </Text>
                        <Text style={styles.marginBottom}>
                          {/* From : RADHAKRISHNAN To {data.partyname} */}
                          From : {data.from} To {data.to}
                        </Text>
                        <Text style={styles.marginBottom}>
                          R.R./L.R. No : {data.receipt_number || "___________"} Inv.
                          No.___________dated__________
                        </Text>
                        <Text style={styles.marginBottom}>
                          Transport GST No :{data.transport_gst_no}
                        </Text>
                        <Text style={styles.marginBottom}>
                          Document through Direct
                        </Text>
                        <Text style={styles.marginBottom}>
                          Each Package has been carefully checked & Packed and we can
                          not accept any responsibility after to the Railway or
                          transport companies.
                        </Text>
                        <Text style={styles.marginBottom}>Rupees : {words} Only</Text>
                      </View>

                      {/* Footer Right Content (Taxation details) */}
                      <View style={styles.footerRight}>
                        <View style={styles.firstFooterOne}>
                          {" "}
                          <Text style={styles.firstFooterTwo}>TOTAL Rs.</Text>
                          <Text style={styles.firstFooterTwo}>
                            IGST{" "}
                            {data.globalGST.startsWith("IGST@")
                              ? parseFloat(data.globalGST.replace("IGST@", ""))
                              : data.products[0].tax_percentage}{" "}
                            % Rs.
                          </Text>

                          <Text style={styles.firstFooterTwo}>
                            CGST{" "}
                            {data.globalGST.startsWith("GST@")
                              ? parseFloat(data.globalGST.replace("GST@", "")) / 2
                              : data.products[0].tax_percentage / 2}{" "}
                            % Rs.
                          </Text>

                          <Text style={styles.firstFooterTwo}>
                            SGST{" "}
                            {data.globalGST.startsWith("GST@")
                              ? parseFloat(data.globalGST.replace("GST@", "")) / 2
                              : data.products[0].tax_percentage / 2}{" "}
                            % Rs.
                          </Text>

                          
                          {/* Use the same height (paddingVertical: 7) even if R.O.A. is 0 */}
                          <Text style={styles.firstFooterTwo}>
                            {parseFloat(data.roundoffAmount) !== 0 ? "R.O.A." : " "}
                          </Text>
                          <Text style={styles.firstFooterTwo}>TOTAL Rs.</Text>
                        </View>
                        <View style={styles.secondFooterOne}>
                          <Text style={styles.secondFooterTwo}>
                            {/* Taxable Value Rs. */}
                            {parseFloat(IGST) > 0
                              ? splitIntoRsPs(data.total - IGST).rs
                              : splitIntoRsPs(data.total - (CGST + SGST)).rs}
                          </Text>
                          <Text style={styles.secondFooterTwo}>
                            {/* IGST Rs. */}
                            {/* Use '-' if IGST is zero */}
                            {parseFloat(data.globalGST.startsWith("IGST@") ? data.taxover_amt : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("IGST@") ? data.taxover_amt : 0.00).rs
                            }
                          </Text>
                          <Text style={styles.secondFooterTwo}>
                            {/* CGST Rs. */}
                            {/* User's snippet for CGST Rs. - kept as is */}
                            {parseFloat(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00).rs
                            }
                          </Text>
                          <Text style={styles.secondFooterTwo}>
                            {/* SGST Rs. */}
                            {/* User's snippet for SGST Rs. - kept as is */}
                            {parseFloat(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00).rs
                            }
                          </Text>
                          <Text style={styles.secondFooterTwo}>
                            {/* R.O.A. Rs. */}
                            {parseFloat(data.roundoffAmount) !== 0 ? data.roundoffAmount.toFixed(2) : " "}
                          </Text>
                          <Text style={[styles.secondFooterTwo, styles.borderTop]}>
                            {/* Final Total Rs. */}
                            {splitIntoRsPs(data.final_total).rs}
                          </Text>
                        </View>

                        <View style={styles.thirdFooterOne}>
                          <Text style={styles.thirdFooterTwo}>
                            {/* Taxable Value Ps. */}
                            {parseFloat(IGST) > 0
                              ? splitIntoRsPs(data.total - IGST).ps
                              : splitIntoRsPs(data.total - (CGST + SGST)).ps}
                          </Text>
                          <Text style={styles.thirdFooterTwo}>
                            {/* IGST Ps. - FIX: Apply conditional logic */}
                            {parseFloat(data.globalGST.startsWith("IGST@") ? data.taxover_amt : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("IGST@") ? data.taxover_amt : 0.00).ps
                            }
                          </Text>
                          <Text style={styles.thirdFooterTwo}>
                            {/* CGST Ps. - FIX: Apply conditional logic */}
                            {parseFloat(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00).ps
                            }
                          </Text>
                          <Text style={styles.thirdFooterTwo}>
                            {/* SGST Ps. - FIX: Apply conditional logic */}
                            {parseFloat(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00) === 0
                              ? "-"
                              : splitIntoRsPs(data.globalGST.startsWith("GST@") ? data.taxover_amt / 2 : 0.00).ps
                            }
                          </Text>
                          <Text style={styles.thirdFooterTwo}>
                            {/* R.O.A. Ps. - FIX: Show '-' since Rs. column has the full amount */}
                            {parseFloat(data.roundoffAmount) !== 0 ? "-" : " "}
                          </Text>
                          <Text style={[styles.thirdFooterTwo, styles.borderTop]}>
                            {/* Final Total Ps. */}
                            {splitIntoRsPs(data.final_total).ps}
                          </Text>
                        </View>

                      </View>
                    </View>
                  </View>
                  {/* Footer Bottom (Signatures) */}
                  <View style={[styles.footerBottom]}>
                    <View style={[styles.headerTop]}>
                      <Text>*Subject to Sivakasi Jurisdiction</Text>
                      <Text style={[styles.footerSign]}>For SUN WORD TRADERS</Text>
                    </View>
                    <View style={[styles.headerTop]}>
                      <Text>E.& 0.E. </Text>
                      <Text>Prepared by: </Text>
                      <Text>Checked by:</Text>
                      <Text>Partner</Text>
                    </View>
                  </View>
                  {/* Thank you note */}
                  <View style={styles.footerNote}>
                    <Text>Thank you</Text>
                  </View>
                </>
              
            
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default InvoicePDF;